import { atom } from 'jotai'

export const companyAtom = atom({})